import Alert, { AlertProps } from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

export const StyledAlert = styled(Alert)<AlertProps>(({ theme }) => ({
    marginBottom: theme.spacing(2),
    width: "97%"
}));
